<template>
  <q-btn
    :label="automationAction.buttonLabel"
    :disable="disable"
    :color="color"
    :flat="flat"
    class="full-width"
    @click="onClickAutomationAction"
  />
</template>
<script>
import { chain } from 'lodash';
import { mapState } from 'pinia';
import { notifyNegative } from 'src/composables/interactions';
import Automation from 'src/mixins/Automation';
import { auth } from 'src/store/auth';

export default {
  name: 'AutomationAction',

  mixins: [Automation],

  props: {
    automationAction: {
      type: Object,
      required: true,
    },
    disable: {
      type: Boolean,
      default: false,
    },
    color: {
      type: String,
      default: 'primary',
    },
    flat: {
      type: Boolean,
      default: false,
    },

  },

  emits: ['done'],

  computed: {
    ...mapState(auth, ['currentClient']),
  },

  methods: {

    async onClickAutomationAction() {
      const confirmText = chain(this.automationAction).get('confirmText').trim().value();
      const runAction = async () => {
        try {
          this.$q.loading.show();
          const automationActionResults = await this.runAutomationAction(this.currentClient.id, this.automationAction);

          if (this.automationAction.doneMessage) {
            this.$q
              .dialog({
                message: this.automationAction.doneMessage,
                persistent: true,
              })
              .onOk(async () => {
                this.$emit('done', automationActionResults);
              });
          } else {
            this.$emit('done', automationActionResults);
          }
        } catch (err) {
          notifyNegative(this.$t('automation.notifyActionError'));
        } finally {
          this.$q.loading.hide();
        }
      };

      if (confirmText) {
        this.$q
          .dialog({
            title: this.$t('common.dialogTitleConfirm'),
            message: confirmText,
            cancel: true,
            persistent: true,
          })
          .onOk(runAction);
      } else {
        runAction();
      }
    }, // onClickAutomationAction()

  },
};
</script>
